import styled from "styled-components";

export const PanelDetails = styled.div`
  background-color: var(--color-feedback-warning-100);
  border: 2px solid var(--color-primary-500);
  border-radius: 4px;
  padding: 12px 16px;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const PairWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PlantLabel = styled.div`
  min-width: 70px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const QuantityLabel = styled.div`
  min-width: 100px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
